import { DatePipe } from "@angular/common";
import { Component, Injector } from "@angular/core";
import { UntypedFormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { BaseEntityComponent, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnConfirmDirective } from "@bndes/bndes-ux4/bn-confirm";
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import { BnUsuarioService, Usuario } from "@bndes/bndes-ux4/bn-usuario";
import moment from "moment";
import { Observable, of } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import { ROLE_GESTOR_ENVIO } from "src/app/constantes/permissao.constants";
import { CanComponentDeactivate } from "src/app/core/can-deactivate-guard.service";
import { AgenteFinanceiro } from "src/app/model/agente-financeiro.model";
import { ESTADO_NOTA, NotaOperacaoGarantida, TIPO_CLASSE_OPERACAO } from "src/app/model/nota.model";
import { FileUtilsService } from "src/app/shared/file-utils.service";
//import Utils from "src/app/shared/fgi-utils";
import { OcorrenciaValidacaoVO } from "src/app/shared/ocorrencia-validacao.vo";
import { PermissaoService } from 'src/app/shared/permissao.service';
import { RemoverAlertasService } from "src/app/shared/services/remover-alertas.service";
import { NotasService } from "../notas.service";


@Component({
    selector: 'app-notas-cadastro',
    templateUrl: './notas-cadastro.component.html',
    standalone: false
})
export class NotasCadastroComponent
        extends BaseEntityComponent<NotaOperacaoGarantida> implements CanComponentDeactivate {
    
    private classesOperacao = TIPO_CLASSE_OPERACAO;
    private estados = ESTADO_NOTA;
    private formNota:UntypedFormGroup = null;
    private agentesFinanceiros:AgenteFinanceiro[]=[];
    private ocorrencias:OcorrenciaValidacaoVO[] = [];
    private usuarioLogado:Usuario;
    private vc: BnConfirmDirective;
    private anexo:File;
    private permissaoEdicao: Boolean;

    constructor(
        private activatedRoute:ActivatedRoute,
        private modalService: BnModalMessageService,
        private permissaoService: PermissaoService,
        protected injector: Injector,
        private usuarioService: BnUsuarioService,
        private notasService: NotasService,
        private datePipe:DatePipe,
        private removerAlertasService: RemoverAlertasService,
        private fileUtils: FileUtilsService,
         ) {
        super(notasService);
        this.config.rotaLista = "notas/pesquisa";
        this.config.bloquearTelaAoRecuperarModelo = true;
        this.agentesFinanceiros = this.activatedRoute.snapshot.data['agentes'];
        this.permissaoEdicao = false;
    }

    ngOnInit(){
        this.formNota = this.createReactiveForm();
        this.usuarioService.usuario$.subscribe(usuario => this.usuarioLogado = usuario);
        this.permissaoService.getPermissoesUsuarioAutenticado().subscribe(resp => {
            let notaOperacao = this.notasService.getNotaTelaOperacao();
            this.permissaoEdicao = resp[ROLE_GESTOR_ENVIO];
            if(notaOperacao){
                this.setModel(notaOperacao);
                this.preencheForm(notaOperacao);
                this.formNota.disable();
                this.config.rotaLista = `operacoes/${notaOperacao.idOperacao}`;
                this.notasService.setNotaTelaOperacao(undefined);
            }
            else{
                this.preparaModelo().subscribe((nota) => {
                    this.setModel(nota);
                    this.preencheForm(nota);
                    if(nota.id){
                       this.formNota.disable();
                    }else{
                        this.formNota.get('estado').disable();
                    }
                    
                    if(this.notasService.getOperacao()){
                        this.notasService.setOperacao(undefined);
                        this.formNota.disable();
                        this.formNota.get('mensagem').enable();
                    }
                });
            }
        });
    }

    preparaModelo(): Observable<NotaOperacaoGarantida> {
        return this.route.params.pipe(
            mergeMap((params) => {
                if (params['id']) {
                    return this.notasService.findById(params['id']);
                } else {
                    let operacao = this.notasService.getOperacao();
                    const novo: NotaOperacaoGarantida = this.notasService.getNewEntity();
                    novo.nomeUsuarioEnvio = this.usuarioLogado.nome;
                    novo.dataEnvio =  moment().format('YYYY-MM-DDTHH:mm:ss');
                    novo.ativo = 'S';
                    super.editar();
                    
                    if(operacao){
                        novo.idOperacao = operacao.id;
                        novo.idAgenteFinanceiro = this.agentesFinanceiros.filter(agente => agente.cnpj === operacao.cnpjAgenteFinanceiro)[0].id;

                        if(operacao.codigoTipoOperacao=='R'){
                            novo.sistemaRepasse = operacao.sistemaCobranca;
                            novo.contratoRepasse = operacao.contratoCobranca;
                        } 
                        else{
                            novo.idOperacaoExterno = operacao.ideExternoOperacao;
                        }
                        this.config.rotaLista = `operacoes/${operacao.id}`;
                    }

                    return of(novo);
                }
            })
        );
    }


    createReactiveForm(): UntypedFormGroup {
       const form = this.formBuilder.group({
            
            idAgenteFinanceiro: [{value: null},Validators.required],

            classeOperacao: [{value: null}],
            
            idOperacaoExterno:[{value: null}],
            
            contratoRepasse:[{value: null}],

            dataEnvio: [{value: null, disabled: true}],

            nomeUsuarioEnvio:[{value:null,disabled: true}],

            estado: [{value: null, disabled: null }],

            mensagem: [{value: null},Validators.compose([Validators.required, Validators.minLength(10), Validators.maxLength(4000)])],

            nomeAnexo: [{value: null}]
        });         
    
            form.get('classeOperacao').valueChanges.subscribe(sistema => {
            const contratoRepasse = form.get('contratoRepasse');
            const idOperacaoExterno = form.get('idOperacaoExterno');

            if (sistema === 'CL') {
                idOperacaoExterno.setValidators([Validators.pattern(/^[A-Za-z0-9_\-]+$/), 
                    Validators.minLength(1), Validators.maxLength(20), Validators.required]);
                if(this.modoEdicao) idOperacaoExterno.enable();
                contratoRepasse.disable();
                contratoRepasse.reset();
                contratoRepasse.clearValidators();

            } else {
                contratoRepasse.setValidators([Validators.pattern(/^[0-9]+$/), 
                    Validators.minLength(11), Validators.maxLength(11), Validators.required]);
                contratoRepasse.enable();
                idOperacaoExterno.disable();
                idOperacaoExterno.reset();
                idOperacaoExterno.clearValidators();
            }
            contratoRepasse.updateValueAndValidity();
            idOperacaoExterno.updateValueAndValidity();
        });

       return form;
    }

    salvar() {

        this.antesDeSalvar();
       
        this.atualizaModel();

        this.ocorrencias = [];
        this.removerAlertasService.removerTodos();
        this.notasService['save'](this.getModel(), this.anexo).subscribe(
            (notaRetornada) => {
                this.model = notaRetornada;
                this.aposSalvar();
            },
            (error) => {
                console.log(error);
                this.ocorrencias = this.notasService.ocorrencias;
            });
    }

    preencheForm(model:NotaOperacaoGarantida){
        this.formNota.patchValue({
            idAgenteFinanceiro: model.idAgenteFinanceiro ? model.idAgenteFinanceiro : null,
            classeOperacao: model.sistemaRepasse ? model.sistemaRepasse : 'CL',
            idOperacaoExterno: model.idOperacaoExterno,
            contratoRepasse: model.contratoRepasse,
            dataEnvio: this.datePipe.transform(model.dataEnvio,"dd/MM/yyyy HH:mm",'pt') ,
            estado: model.ativo,
            mensagem: model.mensagem,
            nomeAnexo: model.nomeAnexo,
            nomeUsuarioEnvio: model.nomeUsuarioEnvio
        });
    }

    habilitarEdicao() {
        this.formNota.get('estado').enable();
        this.formNota.get('mensagem').enable();
        super.editar();
    }

    exibeBotaoParaUsuarioLogado():boolean{
        return this.usuarioLogado.nome.includes(this.model.nomeUsuarioEnvio);
    }

    atualizaModel(){
        const cadastro = this.formNota.value;
        if(cadastro.idOperacaoExterno){
            this.model.idOperacaoExterno = cadastro.idOperacaoExterno;
            this.model.contratoRepasse = null;
        }
        if(cadastro.idAgenteFinanceiro){
            this.model.idAgenteFinanceiro = cadastro.idAgenteFinanceiro;
        }
        if(cadastro.mensagem){
            this.model.mensagem = cadastro.mensagem;
        }
        if(cadastro.estado){
            this.model.ativo = cadastro.estado;
        }
        if(cadastro.contratoRepasse){
            this.model.idOperacaoExterno = null;
        }
        this.model.contratoRepasse = cadastro.contratoRepasse;
        this.model.sistemaRepasse = cadastro.classeOperacao=='CL' ? null : cadastro.classeOperacao;
    }

    voltarParaLista() {
        this.removerAlertasService.removerTodos();
        super.voltarParaLista();
    }

    aposSalvar() {
        this.exibeMensagemSucesso();
        this.formNota.markAsPristine();
        this.formNota.disable();
        this.modoEdicao = false;
       // super.alternarEdicao();
    }
    
    exibeMensagemSucesso(): void {
        this.messageService.addMessage({
            title: 'Sucesso',
            type: 'CRUD_OPERATION',
            level: messageLevel.SUCCESS,
            message: 'Nota criada/atualizada com sucesso.'
        });
    }
        
    exportarAnexo(){
        this.notasService.getAnexo(this.model.id).subscribe((conteudo) => {
            this.fileUtils.exportarArquivo(this.model.nomeAnexo, conteudo, FileUtilsService.APPLICATION_OCTEC);
        });

    }
    
    preparaUpload(input:HTMLInputElement):String{
        this.anexo = input?.files[0];
        this.model.nomeAnexo = input?.files[0]?.name || null;
        return this.anexo?.name || "Arquivo indisponível! ";
    }

    async verificaSePodeSair(): Promise<boolean> {
        const titulo = 'Confirmação';
        const mensagem = this.model.id!=null ? 'Descartar alterações realizadas na nota ?' : 'Descartar novo cadastro de nota ?';

        try {
            const resultadoConfimacao = await this.modalService.abrirConfirm(titulo, mensagem).result;
            return resultadoConfimacao.value === 'ok';
        } catch (e) {
            return false;
        }
    }

    canDeactivate(): Promise<boolean> | boolean {
        if (!this.modoEdicao || this.formNota.valid) 
            return true;
        
        return this.verificaSePodeSair();
    }
}
